// Module
var code = `<div class="recover-password-screen">
    <!-- First step -->
    <!-- {{#if currentStep === TerceraRecoverScreen.CredentialStep}} --> <!-- loginTextBox must be present at the stage of registering the container's controls to be accessed by name.-->
    <div class="recover-password-screen-selector{{currentStep === TerceraRecoverScreen.CredentialStep?'':' hided'}}">
        <terceraTextBox name="loginTextBox" text="{{.valueLogin}}" placeholder="{{.textLoginLabel}}"/>
        <terceraTextBox name="emailTextBox" text="{{.valueEmail}}" placeholder="{{.textEmailLabel}}" />
    </div>
    <!-- {{/if}} -->

    <!-- Second step -->
    <!-- {{#if currentStep === TerceraRecoverScreen.VerificationCodeStep}} --> <!-- keyTextBox must be present at the stage of registering the container's controls to be accessed by name.-->
    <div class="recover-password-screen-selector{{currentStep === TerceraRecoverScreen.VerificationCodeStep?'':' hided'}}">
        <terceraTextBox name="keyTextBox" text="{{.valueKey}}" placeholder="{{.textKeyLabel}}"/>
        <div class="recover-password-screen-hint">{{.hintText}}</div>
    </div>
    <!-- {{/if}} -->

    <!-- Third step -->
    {{#if currentStep === TerceraRecoverScreen.NewPasswordStep}}
    <div class="recover-password-screen-selector">
        <passwordTextBox passwordHided="{{newPassHided}}" text="{{.valueNewPassword}}" showPasswordPreview="{{.allowPasswordPreview}}" placeholder="{{.textNewPasswordLabel}}" name="newPassword"/>

        <passwordTextBox passwordHided="{{confirmPassHided}}" text="{{.valueConfirm}}" showPasswordPreview="{{.allowPasswordPreview}}" placeholder="{{.textConfirmLabel}}" name="newPasswordConfirm"/>
    </div>
    {{/if}}



    <!-- Footer -->
    <div class="recover-password-screen-selector-footer">
        <!-- Progress bar -->
        <StepProgressBar labels="{{progressStepLabels}}" currentStep="{{currentStep}}"/>
        <div class="recover-screen-footer-buttons">
            <!-- Back button -->
            {{#if @this.backBtnVisible()}}
            <terceraButton name="ArrowLeft" SVG="true"
                text="{{backText}}" on-btnClick="@this.backClick()"
                terceraButtonStyle="back-button"/>
            {{/if}}

            <!-- Next button -->
            {{#if @this.nextBtnVisible()}}
            <terceraButton name="ArrowRight" SVG="true" enabled="{{nextBtnEnabled}}" 
                text="{{nextText}}" on-btnClick="@this.nextClick()"
                terceraButtonStyle="next-button"/>
            {{/if}}

            <!-- Finish button -->
            {{#if @this.finishBtnVisible()}}
            <terceraButton enabled="{{recoverBtnEnabled}}" 
                text="{{recoverText}}" on-btnClick="@this.nextClick()"
                terceraButtonStyle="next-button"/>
            {{/if}}
        </div>
    </div>
</div>`;
// Exports
export default code;